import React, { useEffect, useState } from 'react';
import { Button, Form, Popover, Result } from 'antd';
import { FormBox, InputBox } from '../../../components/AntdAddons';
import LoginBG from '../../../assets/images/login-pattern.png';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { LoginRequest } from './Validation';
import { assignErrorToInput } from '../../../store/api';
import { AppDispatch } from '../../../store/app';
import { useDispatch } from 'react-redux';
import { updatePassword, checkOTP } from '../../../store/AuthSlice';
import { validations } from '../../../config/validations/validations';
import Logo from '../../../assets/images/logo.svg';
import LoginBanner from '../../../assets/images/login-banner-2.gif';

type RouteParams = {
  userid: string;
  otp: string;
} & Record<string, string | undefined>;

const ResetPassword: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const [form] = Form.useForm();
  const [disable, setDisable] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);
  const [tooltip, setTooltip] = useState(false);
  const navigate = useNavigate();
  const { userid, otp } = useParams<RouteParams>();
  const [isOTP, setIsOTP] = useState<number>();

  useEffect(() => {
    if (userid && otp) {
      const payload = {
        user_id: userid,
        otp: otp,
      };

      dispatch(checkOTP(payload))
        .then((res: any) => {
          //console.log('res checkOTP', res);

          setIsOTP(res?.isOTP);
          if (res?.isOTP === 2) {
            navigate('/forgot-password');
          }
          setDisable(false);
        })
        .catch((err: any) => {
          //console.log('res checkOTP', err);
          setIsOTP(err?.data?.isOTP);
          if (err?.isOTP === 2) {
            navigate('/forgot-password');
          }
        });
    }
  }, [userid, otp, dispatch, navigate]);

  const handleSubmit = (data: any) => {
    localStorage.removeItem('token');
    localStorage.clear();
    setSaving(true);

    if (userid && otp) {
      const payload = {
        ...data,
        user_id: userid,
        otp: otp,
      };

      dispatch(updatePassword(payload))
        .then(() => {
          setSaving(false);
          navigate('/login');
        })
        .catch((error: any) => {
          assignErrorToInput(form, error?.STATUS);
        })
        .finally(() => setSaving(false));
    }
  };

  const onChange = () => {
    form
      .validateFields(['password'])
      .then(() => {
        setTooltip(false);
      })
      .catch(() => {
        setTooltip(true);
      });
  };

  // password criteria tool tip
  const passwordTooltip = (
    <div>
      <div>at least 1 numeric character</div>
      <div>at least 1 special character</div>
      <div>at least 1 uppercase letter</div>
      <div>at least 8 character</div>
    </div>
  );

  return (
    <section className="loginSection">
      <div className="loginWrap">
        {isOTP === 0 ? (
          <>
            <div
              className="loginForm"
              style={{ backgroundImage: `url(${LoginBG})` }}
            >
              <Result
                status="403"
                title="403"
                subTitle="Sorry, you are not authorized to access this page."
                extra={
                  <div
                    className="text-center"
                    style={{ width: '100%', backgroundColor: 'transparent' }}
                  >
                    <div className="ant-form  text-center">
                      <Button
                        size="large"
                        type="primary"
                      >
                        <Link to={'/login'}>Go to Login</Link>
                      </Button>
                    </div>
                  </div>
                }
              />
            </div>
          </>
        ) : (
          <div
            className="loginForm"
            style={{ backgroundImage: `url(${LoginBG})` }}
          >
            <div className="loginFormWrap">
              <img
                src={Logo}
                alt="logo"
                className="logo"
              />
              <div className="formTitle">
                <h2 className="title">Reset Password</h2>
              </div>
              <FormBox
                form={form}
                onFinish={handleSubmit}
                onChange={onChange}
              >
                {/* <InputBox.Text
              name="email"
              // label={'Email ID'}
              type="email"
              placeholder="Email ID"
              rules={[
                validations.required.text('Email ID'),
                validations.pattern.email('Email ID'),
              ]}
            /> */}
                <Popover
                  placement="left"
                  content={passwordTooltip}
                  open={tooltip}
                >
                  <InputBox.Password
                    name="password"
                    // label="Password"
                    placeholder="Password *"
                    // rules={LoginRequest().password()}
                    rules={[
                      validations.required.text('Password'),
                      validations.pattern.password('Password'),
                      validations.pattern.whitespace,
                      validations.min.text(8, 'Password'),
                      validations.max.text(20, 'Password'),
                    ]}
                  />
                </Popover>
                <InputBox.Password
                  name="confirm_password"
                  // label="Confirm Password"
                  placeholder="Confirm Password *"
                  rules={LoginRequest().confirmPassword('Confirm Password')}
                />
                {/* <InputBox.Text
              name="otp"
              label={'Otp'}
              type="otp"
              // placeholder="example@domain.com"
            /> */}
                <div className="text-left mt-40 resetPassword">
                  <Button
                    loading={saving}
                    disabled={disable}
                    type="primary"
                    htmlType="submit"
                  >
                    Reset Password
                  </Button>
                </div>
                <div className="text-right mt-10 font-medium text-white">
                  <Link
                    to="/login"
                    className="link"
                  >
                    Back to Login
                  </Link>
                </div>
              </FormBox>
              <div className="circleBottomRight"></div>
              <div className="squareTop"></div>
            </div>
          </div>
        )}

        <img
          src={LoginBanner}
          alt=""
          className="LoginBanner"
        />
      </div>
    </section>
  );
};

export default ResetPassword;
